import Vue from "vue";
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
/**
 * setter
 * @method setCampaign
 * @method setTitle
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCLickConfirm
 * @method onClickCancel
 * event
 * @event onClickConfirm
 * @event onClickCancel
 */
export function ConfirmRedeemModalController () {
    this.campaign = '';
    this.tag = '';
    this.busModal = new Vue();

    this.cbConfirm = new CallbackEvent();
    this.cbCancel = new CallbackEvent();

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaign = null;
        this.tag = '';
        this.cbConfirm.clearCallback();
        this.cbCancel.clearCallback();

        return this;
    };
    //#endregion setter
    //#region action
    this.show = function () {
        var config = {
            campaign: this.campaign,
            tag: this.tag
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion action

    //#region event
    this.onClickConfirm = function(callback) {
        this.cbConfirm.onCallback(callback);
    };
    this.eventClickConfirm = function(info) {
        this.cbConfirm.sendCallback(info);
    };

    this.onClickCancel = function(callback) {
        this.cbCancel.onCallback(callback);
    };
    this.eventClickCancel = function(info) {
        this.cbCancel.sendCallback(info);
    };
    //#endregion event
}
